// ============================================================
// cf-skeleton.js � Global Skeleton Shimmer Helper
// Dimuat di SETIAP halaman via _Layout.cshtml (setelah site.js).
//
// Provides CF.skeleton with reusable methods:
//
//   CF.skeleton.table(tbodyEl, cols, rows)
//       Inject shimmer rows into a <tbody>. Reads actual <thead>
//       column count if cols=0. Default 6 cols, 10 rows.
//
//   CF.skeleton.grid(container, cols, rows, height)
//       Inject a grid of shimmer cards into a container.
//
//   CF.skeleton.lines(container, count)
//       Inject shimmer text lines into a container.
//
//   CF.skeleton.remove(container, fadeMs)
//       Fade out and remove .cf-sk elements inside container.
//
// All generated elements have class "cf-sk" for easy cleanup.
// CSS shimmer animation is defined in _skeleton.css.
// ============================================================

window.CF = window.CF || {};

CF.skeleton = (function () {
    'use strict';

    // ?? Table skeleton ??????????????????????????????????????
    // Fills <tbody> with shimmer rows. Each cell gets a rounded
    // bar with slightly varied widths for a natural look.
    function table(tbodyEl, cols, rows) {
        if (!tbodyEl) return;

        // Auto-detect column count from <thead> if not specified
        if (!cols || cols <= 0) {
            var table = tbodyEl.closest('table');
            if (table) {
                var ths = table.querySelectorAll('thead th');
                cols = ths.length || 6;
            } else {
                cols = 6;
            }
        }
        rows = rows || 10;

        // Width pattern � gives each cell a slightly different width
        // so the skeleton looks organic, not a flat grid
        var widths = [88, 72, 95, 65, 80, 58, 90, 70, 85, 60];

        var html = '';
        for (var r = 0; r < rows; r++) {
            html += '<tr class="cf-sk cf-sk-row">';
            for (var c = 0; c < cols; c++) {
                var w = widths[(r + c * 3) % widths.length];
                html += '<td><span class="cf-sk-bar" style="width:' + w + '%"></span></td>';
            }
            html += '</tr>';
        }
        tbodyEl.innerHTML = html;
    }

    // ?? Grid skeleton (cards) ???????????????????????????????
    function grid(container, cols, rows, height) {
        if (!container) return;
        cols   = cols   || 3;
        rows   = rows   || 2;
        height = height || '120px';

        var html = '<div class="cf-sk cf-sk-grid" style="' +
            'display:grid;grid-template-columns:repeat(' + cols + ',1fr);gap:16px">';
        for (var i = 0; i < cols * rows; i++) {
            html += '<div class="cf-sk-card" style="height:' + height + '"></div>';
        }
        html += '</div>';
        container.insertAdjacentHTML('afterbegin', html);
    }

    // ?? Lines skeleton (text) ???????????????????????????????
    function lines(container, count) {
        if (!container) return;
        count = count || 4;

        var widths = [100, 85, 92, 70, 95, 78];
        var html = '<div class="cf-sk cf-sk-lines">';
        for (var i = 0; i < count; i++) {
            var w = widths[i % widths.length];
            html += '<span class="cf-sk-bar" style="width:' + w + '%;height:14px;margin-bottom:10px"></span>';
        }
        html += '</div>';
        container.insertAdjacentHTML('afterbegin', html);
    }

    // ?? Remove skeleton ?????????????????????????????????????
    // Fades out all .cf-sk elements inside container, then removes them.
    function remove(container, fadeMs) {
        if (!container) return;
        fadeMs = fadeMs || 200;

        var skels = container.querySelectorAll('.cf-sk');
        if (!skels.length) return;

        skels.forEach(function (el) {
            el.style.transition = 'opacity ' + fadeMs + 'ms ease';
            el.style.opacity = '0';
        });

        setTimeout(function () {
            skels.forEach(function (el) { el.remove(); });
        }, fadeMs);
    }

    return {
        table:  table,
        grid:   grid,
        lines:  lines,
        remove: remove
    };
})();
